export default function ArrowCircleBrokenUpRight({ ...props }) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.94883 12.1593C1.2064 9.37912 1.92571 6.28982 4.10679 4.10875C7.36116 0.854376 12.6375 0.854376 15.8919 4.10875C19.1463 7.36311 19.1463 12.6395 15.8919 15.8939C13.7108 18.0749 10.6215 18.7943 7.84139 18.0518M12.4995 12.5014V7.50139M12.4995 7.50139H7.49946M12.4995 7.50139L4.16597 15.8347"
                stroke="currentColor"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
}
